import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../../css/splash/quote.css";
import { QuoteData, ProductCardsData } from "./SplashData";

export const Quote = () => {
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [productsVisible, setProductsVisible] = useState(false);
  const sectionRefs = useRef([]);
  const productsRef = useRef(null);

  useEffect(() => {
    const observers = [];
    
    // Observer for products section
    if (productsRef.current) {
      const productsObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setProductsVisible(true);
            }
          });
        },
        { threshold: 0.2 }
      );
      productsObserver.observe(productsRef.current);
      observers.push(productsObserver);
    }
    
    // Observer for other sections
    sectionRefs.current.forEach((ref, index) => {
      if (!ref) return;
      
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setVisibleSections((prev) => new Set([...prev, index]));
            }
          });
        },
        { threshold: 0.2 }
      );
      
      observer.observe(ref);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  return (
    <>
      {/* Products Section - Row of Three Cards */}
      <div className="products-section-container">
        <div className="products-section" ref={productsRef}>
          <h2 className="products-section-title">Our Products</h2>
          <div className="products-cards-wrapper">
            {ProductCardsData.map((product, index) => (
              <Link 
                key={index}
                to={product.link}
                className={`product-card ${productsVisible ? "visible" : ""}`}
              >
                <div 
                  className="product-card-image"
                  style={{
                    backgroundImage: `url(${product.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <div className="product-card-overlay"></div>
                  <h3 className="product-card-title">{product.title}</h3>
                  <p className="product-card-description">{product.description}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      
      <div className="quote-container">

      {/* Commented out original cards */}
      {/* {QuoteData.slice(0, 3).map((section, index) => (
        <div
          key={index}
          ref={(el) => (sectionRefs.current[index] = el)}
          className={`quote-section ${visibleSections.has(index) ? "visible" : ""}`}
          style={
            section.backgroundImage
              ? {
                  backgroundImage: `url(${section.backgroundImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }
              : {}
          }
        >
          <h2 className="section-title">{section.title}</h2>

          <div className="section-content">
            <div className="text-container">
              <ul>
                {section.textContent.map((bullet, bulletIndex) => (
                  <li key={bulletIndex}>{bullet}</li>
                ))}
              </ul>
            </div>

            {(section.href || section.hrefs) && (
              <div className="image-container parallax-image">
                {section.href ? (
                  <img
                    src={section.href}
                    alt={section.title}
                    className="section-image"
                  />
                ) : (
                  <div className="image-grid">
                    {section.hrefs.map((href, hrefIndex) => (
                      <img
                        key={hrefIndex}
                        src={href}
                        alt={""}
                        className="section-image"
                      />
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ))} */}

        {/* Keep the Sales Traction section */}
        {QuoteData.slice(3).map((section, index) => (
          <div
            key={index}
            ref={(el) => (sectionRefs.current[index] = el)}
            className={`quote-section ${visibleSections.has(index) ? "visible" : ""} ${section.title === "Key Partners" ? "key-partners-section" : ""}`}
            style={
              section.backgroundImage
                ? {
                    backgroundImage: `url(${section.backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                  }
                : {}
            }
          >
            <h2 className="section-title">{section.title}</h2>

            <div className="section-content">
              {section.textContent && section.textContent.length > 0 && (
                <div className="text-container">
                  <ul>
                    {section.textContent.map((bullet, bulletIndex) => (
                      <li key={bulletIndex}>{bullet}</li>
                    ))}
                  </ul>
                </div>
              )}

              {(section.href || section.hrefs) && (
                <div className="image-container parallax-image">
                  {section.href ? (
                    <img
                      src={section.href}
                      alt={section.title}
                      className="section-image"
                    />
                  ) : (
                    <div className="image-grid">
                      {section.hrefs.map((logo, hrefIndex) => (
                        <a
                          key={hrefIndex}
                          href={logo.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="logo-link"
                        >
                          <img
                            src={logo.image}
                            alt={logo.alt}
                            className="section-image"
                          />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
